// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "1.19.5/static/js/" + chunkId + "." + {"275":"1c21a3e1","450":"c18d9b82"}[chunkId] + ".chunk.js";
};